"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ledger = exports.LedgerInitError = exports.LedgerWebHIDIniter = exports.LedgerWebUSBIniter = exports.LedgerInitErrorOn = exports.LedgerApp = void 0;
const hw_transport_webhid_1 = __importDefault(require("@ledgerhq/hw-transport-webhid"));
const hw_transport_webusb_1 = __importDefault(require("@ledgerhq/hw-transport-webusb"));
const secp256k1_1 = require("secp256k1");
const router_1 = require("@keplr-wallet/router");
const hw_app_eth_1 = __importDefault(require("@ledgerhq/hw-app-eth"));
const types_1 = require("@keplr-wallet/types");
const keyring_1 = require("../keyring");
const transactions_1 = require("@ethersproject/transactions");
const buffer_1 = require("buffer/");
const utils_1 = require("../keyring/utils");
const ledger_cosmos_1 = require("@keplr-wallet/ledger-cosmos");
var LedgerApp;
(function (LedgerApp) {
    LedgerApp["Cosmos"] = "cosmos";
    LedgerApp["Ethereum"] = "ethereum";
})(LedgerApp = exports.LedgerApp || (exports.LedgerApp = {}));
var LedgerInitErrorOn;
(function (LedgerInitErrorOn) {
    LedgerInitErrorOn[LedgerInitErrorOn["Transport"] = 0] = "Transport";
    LedgerInitErrorOn[LedgerInitErrorOn["App"] = 1] = "App";
    LedgerInitErrorOn[LedgerInitErrorOn["Unknown"] = 2] = "Unknown";
})(LedgerInitErrorOn = exports.LedgerInitErrorOn || (exports.LedgerInitErrorOn = {}));
const LedgerWebUSBIniter = () => __awaiter(void 0, void 0, void 0, function* () {
    return yield hw_transport_webusb_1.default.create();
});
exports.LedgerWebUSBIniter = LedgerWebUSBIniter;
const LedgerWebHIDIniter = () => __awaiter(void 0, void 0, void 0, function* () {
    return yield hw_transport_webhid_1.default.create();
});
exports.LedgerWebHIDIniter = LedgerWebHIDIniter;
class LedgerInitError extends Error {
    constructor(errorOn, message) {
        super(message);
        this.errorOn = errorOn;
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, LedgerInitError.prototype);
    }
}
exports.LedgerInitError = LedgerInitError;
class Ledger {
    constructor(cosmosApp = undefined, ethereumApp = undefined) {
        this.cosmosApp = cosmosApp;
        this.ethereumApp = ethereumApp;
    }
    static init(transportIniter, initArgs = [], app, cosmosLikeApp) {
        return __awaiter(this, void 0, void 0, function* () {
            const transport = yield transportIniter(...initArgs);
            try {
                if (app === LedgerApp.Ethereum) {
                    const ethereumApp = new hw_app_eth_1.default(transport);
                    // Ensure that the keplr can connect to ethereum app on ledger.
                    // getAppConfiguration() works even if the ledger is on screen saver mode.
                    // To detect the screen saver mode, we should request the address before using.
                    yield ethereumApp.getAddress("m/44'/60'/0'/0/0");
                    return new Ledger(undefined, ethereumApp);
                }
                const cosmosApp = new ledger_cosmos_1.CosmosApp(cosmosLikeApp, transport);
                const ledger = new Ledger(cosmosApp, undefined);
                const versionResponse = yield ledger.getVersion();
                // In this case, device is on screen saver.
                // However, it is almost same as that the device is not unlocked to user-side.
                // So, handle this case as initializing failed in `Transport`.
                if (versionResponse.deviceLocked) {
                    throw new router_1.KeplrError("ledger", 102, "Device is on screen saver");
                }
                let appName = "";
                try {
                    const appInfo = yield cosmosApp.getAppInfo();
                    appName = appInfo.app_name;
                }
                catch (e) {
                    console.log(e);
                }
                if (appName && appName !== cosmosLikeApp) {
                    throw new router_1.KeplrError("ledger", 122, "Invalid cosmos app selected");
                }
                return ledger;
            }
            catch (e) {
                if (transport) {
                    yield transport.close();
                }
                if (e.message === "Device is on screen saver") {
                    throw new LedgerInitError(LedgerInitErrorOn.Transport, e.message);
                }
                throw new LedgerInitError(LedgerInitErrorOn.App, e.message);
            }
        });
    }
    getVersion() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.cosmosApp) {
                throw new router_1.KeplrError("ledger", 100, "Cosmos App not initialized");
            }
            const result = yield this.cosmosApp.getVersion();
            if (result.error_message !== "No errors") {
                throw new Error(result.error_message);
            }
            return {
                deviceLocked: (_a = result.device_locked) !== null && _a !== void 0 ? _a : false,
                major: result.major,
                minor: result.minor,
                patch: result.patch,
                targetId: result.target_id,
                testMode: result.test_mode,
            };
        });
    }
    getPublicKey(app, fields) {
        return __awaiter(this, void 0, void 0, function* () {
            if (app === LedgerApp.Ethereum) {
                if (!this.ethereumApp) {
                    throw new router_1.KeplrError("ledger", 100, "Ethereum App not initialized");
                }
                try {
                    const result = yield this.ethereumApp.getAddress(Ledger.pathToString(Ledger.createPath(60, fields)));
                    const pubKey = buffer_1.Buffer.from(result.publicKey, "hex");
                    // Compress the public key
                    return secp256k1_1.publicKeyConvert(pubKey, true);
                }
                catch (e) {
                    throw new Error(e);
                }
            }
            else {
                if (!this.cosmosApp) {
                    throw new router_1.KeplrError("ledger", 100, "Cosmos App not initialized");
                }
                const result = yield this.cosmosApp.getPublicKey(fields.account, fields.change, fields.addressIndex);
                if (result.error_message !== "No errors") {
                    throw new Error(result.error_message);
                }
                return result.compressed_pk;
            }
        });
    }
    sign(fields, message) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.cosmosApp) {
                throw new router_1.KeplrError("ledger", 100, "Cosmos App not initialized");
            }
            const result = yield this.cosmosApp.sign(fields.account, fields.change, fields.addressIndex, message);
            if (result.error_message !== "No errors") {
                throw new Error(result.error_message);
            }
            // Parse a DER ECDSA signature
            return secp256k1_1.signatureImport(result.signature);
        });
    }
    signEthereum(fields, signType, message) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.ethereumApp) {
                throw new router_1.KeplrError("ledger", 100, "Ethereum App not initialized");
            }
            const formattedPath = Ledger.pathToString(Ledger.createPath(60, fields));
            switch (signType) {
                case types_1.EthSignType.MESSAGE: {
                    const signature = yield this.ethereumApp.signPersonalMessage(formattedPath, buffer_1.Buffer.from(message).toString("hex"));
                    return Ledger.ethSignatureToBytes(signature);
                }
                case types_1.EthSignType.TRANSACTION: {
                    const tx = JSON.parse(buffer_1.Buffer.from(message).toString());
                    const rlpArray = transactions_1.serialize(tx).replace("0x", "");
                    const signature = yield this.ethereumApp.signTransaction(formattedPath, rlpArray);
                    const signedTx = transactions_1.serialize(tx, {
                        r: `0x${signature.r}`,
                        s: `0x${signature.s}`,
                        v: parseInt(signature.v, 16),
                    }).replace("0x", "");
                    return buffer_1.Buffer.from(signedTx, "hex");
                }
                case types_1.EthSignType.EIP712: {
                    const data = yield keyring_1.EIP712MessageValidator.validateAsync(JSON.parse(buffer_1.Buffer.from(message).toString()));
                    // Unfortunately, signEIP712Message not works on ledger yet.
                    return Ledger.ethSignatureToBytes(yield this.ethereumApp.signEIP712HashedMessage(formattedPath, utils_1.domainHash(data), utils_1.messageHash(data)));
                }
                default:
                    throw new Error(`Unknown sign type: ${signType}`);
            }
        });
    }
    close() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.cosmosApp) {
                yield this.cosmosApp.transport.close();
            }
            if (this.ethereumApp) {
                yield this.ethereumApp.transport.close();
            }
        });
    }
    static isWebHIDSupported() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield hw_transport_webhid_1.default.isSupported();
        });
    }
    static createPath(coinType, fields) {
        return [44, coinType, fields.account, fields.change, fields.addressIndex];
    }
    // Convert a path represented by number[] to the string format
    // expected by the Ethereum Ledger app.
    static pathToString(path) {
        if (path.length !== 5) {
            throw new Error(`Invalid path for bip44: ${path.join(",")}`);
        }
        let res = "m";
        let c = 0;
        path.forEach((el) => {
            res = res.concat(`/${el}`);
            // Harden the first three values by default
            if (c < 3) {
                res = res.concat("'");
            }
            c++;
        });
        return res;
    }
    // Convert an Ethereum signature object to bytes to be returned.
    static ethSignatureToBytes(signature) {
        // Validate signature.r is hex encoded
        const r = buffer_1.Buffer.from(signature.r, "hex");
        // Validate signature.s is hex encoded
        const s = buffer_1.Buffer.from(signature.s, "hex");
        // Must be 32 bytes
        if (r.length !== 32 || s.length !== 32) {
            throw new Error("Unable to process signature: malformed fields");
        }
        if (!Number.isInteger(signature.v)) {
            throw new Error("Unable to process signature: malformed fields");
        }
        return buffer_1.Buffer.concat([r, s, buffer_1.Buffer.from([signature.v])]);
    }
}
exports.Ledger = Ledger;
//# sourceMappingURL=ledger.js.map